import React, { useState, useEffect } from 'react';
import { getGroupsByTerm, assignStudentToGroup } from '../utils/api';
import { mapErrorMessage } from '../utils/errorMapping';
import './_Modal.css';

const AssignStudentToGroupFromStudentPageModal = ({ studentId, onClose, onGroupAssigned }) => {
    const [terms, setTerms] = useState([]);
    const [selectedTerm, setSelectedTerm] = useState('');
    const [selectedLevel, setSelectedLevel] = useState('');
    const [selectedStream, setSelectedStream] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');

    useEffect(() => {
        const getTerms = async () => {
            try {
                const response = await getGroupsByTerm();
                setTerms(response.data);
            } catch (error) {
                setError(mapErrorMessage(error.message));
            }
        };
        getTerms();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        if (!selectedStream) {
            setError('Please select a group.');
            return;
        }

        try {
            await assignStudentToGroup(studentId, parseInt(selectedStream, 10));
            setMessage('Student assigned to group successfully.');
            onGroupAssigned();
        } catch (error) {
            setError(mapErrorMessage(error.message));
        }
    };

    const handleTermChange = (e) => {
        setSelectedTerm(e.target.value);
        setSelectedLevel('');
        setSelectedStream('');
    };

    const handleLevelChange = (e) => {
        setSelectedLevel(e.target.value);
        setSelectedStream('');
    };

    const handleStreamChange = (e) => {
        setSelectedStream(e.target.value);
    };

    const currentTerm = terms.find(term => term.id === parseInt(selectedTerm));
    const currentLevel = currentTerm?.levels.find(level => level.id === parseInt(selectedLevel));

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose}>X</button>
                <h2>Assign Student to Group</h2>
                {error && <p className="error">{error}</p>}
                {message && <p className="message">{message}</p>}
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Term</label>
                        <select value={selectedTerm} onChange={handleTermChange}>
                            <option value="">Select Term</option>
                            {terms.map(term => (
                                <option key={term.id} value={term.id}>{term.name}</option>
                            ))}
                        </select>
                    </div>
                    {selectedTerm && (
                        <div className="form-group">
                            <label>Level</label>
                            <select value={selectedLevel} onChange={handleLevelChange}>
                                <option value="">Select Level</option>
                                {currentTerm.levels.map(level => (
                                    <option key={level.id} value={level.id}>{level.name}</option>
                                ))}
                            </select>
                        </div>
                    )}
                    {selectedLevel && (
                        <div className="form-group">
                            <label>Stream</label>
                            <select value={selectedStream} onChange={handleStreamChange}>
                                <option value="">Select Stream</option>
                                {currentLevel.streams.map(stream => (
                                    <option key={stream.group_id} value={stream.group_id}>
                                        {stream.name} ({stream.student_count} students)
                                    </option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className="actions-centered">
                        <button type="button" onClick={onClose} className="cancel-button text-button">Cancel</button>
                        <button type="submit" className="submit-button text-button">Assign</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AssignStudentToGroupFromStudentPageModal;